<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-6" style="margin-bottom: 10px;">
                Notification Type
                <treeselect
                    :multiple="true"
                    :options="types"
                    value-consists-of="LEAF_PRIORITY"
                    v-model="api_params.types"
                ></treeselect>
            </div>


            <div class="col-md-6">
                Notification Status

                <treeselect
                    :multiple="true"
                    :options="statuses"
                    value-consists-of="LEAF_PRIORITY"
                    v-model="api_params.status"
                ></treeselect>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6" style="margin-top: 10px;">
                Agency
                <treeselect
                    :multiple="true"
                    :options="agencies"
                    :normalizer="agencyTreeSelectNormalizer"
                    :searchable="true"
                    value-consists-of="LEAF_PRIORITY"
                    v-model="api_params.agency_id"
                ></treeselect>
            </div>

            <div class="col-md-6" style="margin-top: 10px;">
                Text Search
                <input type="search" v-model="api_params.search" class="form-control" @keyup.enter="search">
            </div>

            <div class="col-md-12" style="margin-top: 20px;">
                <button class="btn btn-primary btn-block" @click.prevent="search"><i class="fa fa-search"></i> Search</button>
            </div>
        </div>
        <div class="row" style="margin-top:20px;">
            <pagination :current_page="pagination.current_page"
                        :total_pages="pagination.total_pages"
                        :from="pagination.from"
                        :to="pagination.to"
                        :total="pagination.total"
                        @go-to-page="handleGoToPage"
                        v-show="showPagination"
            ></pagination>
            <div class="col-lg-8 col-md-8 col-sm-12 form-inline text-right">
                <div class="col-lg-12 text-right" style="margin-bottom: 20px;">
                    <div class="input-group" v-show="hasSelectedNotifications">
                        <select v-model="massUpdateStatusId" class="form-control">
                            <option value="">Mass update status</option>
                            <option v-for="status in statuses" :value="status.id">{{ status.label }}</option>
                        </select>
                        <span class="input-group-btn">
                        <button class="btn btn-success" @click.prevent="saveMassStatusUpdate"><i class="fa fa-save"></i></button>
                    </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="table-responsive">
                    <table class="table table-striped microsites-table">
                        <thead v-show="showTableHeaders">
                        <tr class="side-borders th_font">
                            <th style="width: 29px">
                                <input type="checkbox" v-model="selectAllState">
                            </th>
                            <th v-for="header in headers" @click="sortHeader(header.name)" :style="{ width: getHeaderWidth(header) }">
                                {{ header.name | capitalize }}
                                <i class="fas fa-sort-down" v-if="header.sort === 'desc'"></i>
                                <i class="fas fa-sort-up" v-if="header.sort === 'asc'"></i>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-show="showLoading">
                            <td colspan="6" class="text-center">
                                <i class="fa fa-spinner fa-spin fa-3x grey"></i><br/><br/>
                                Loading Notifications
                            </td>
                        </tr>
                        <tr v-show="showNoResultsFound">
                            <td colspan="6" class="text-center">
                                No results found
                            </td>
                        </tr>
                        <tr v-for="notification in notifications" v-if="!showLoading">
                            <td><input type="checkbox" :value="notification.id" v-model="selectedNotifications"></td>
                            <td>{{ notification.created_at }}</td>
                            <td><a href="#" @click.prevent="applyFilterByAgency(notification.agency.id)">{{ notification.agency.name }}
                                ({{ notification.agency.id }})</a></td>
                            <td><a href="#" @click.prevent="applyFilterByType(notification.type)">{{ notification.type }}</a>
                                <span class="pull-right">
                                        <i class="fa fa-sync-alt fa-spin" v-if="notification.dirty"></i>
                                        <i class="fa fa-bell-slash" v-if="notification.snooze_clicked"></i>
                                    </span>
                            </td>
                            <td>{{ notification.text }}</td>
                            <td><a href="#" @click.prevent="applyFilterByStatus(notification.status.id)">{{ notification.status.name }}</a>
                            </td>
                            <td>
                                <a :href="'#/'+notification.id" class="btn btn-sm btn-info" @click.prevent="showMoreInfo(notification)">
                                    <i class="fas fa-info"></i>
                                </a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-7">
                <pagination :current_page="pagination.current_page"
                            :total_pages="pagination.total_pages"
                            :from="pagination.from"
                            :to="pagination.to"
                            :total="pagination.total"
                            @go-to-page="handleGoToPage"
                            v-show="showPagination"
                ></pagination>
            </div>

            <div class="col-sm-5 text-right" v-show="!showLoading">
                <div>
                    <a href="/notifier/snoozes"><h4>Configure snoozes...</h4></a><br>
                </div>

                <div class="form-inline" style="margin-bottom: 20px;">
                    <div class="input-group" v-show="hasSelectedNotifications">
                        <select v-model="massUpdateStatusId" class="form-control">
                            <option value="">Mass update status</option>
                            <option v-for="status in statuses" :value="status.id">{{ status.label }}</option>
                        </select>
                        <span class="input-group-btn">
                            <button class="btn btn-success" @click.prevent="saveMassStatusUpdate"><i class="fa fa-save"></i></button>
                        </span>
                    </div>
                </div>
            </div>

        </div>
        <notification-more-info-modal
            :notification="modalNotification"
            :statuses="statuses"
            :environment="environment"
            v-if="isShowModal"
            @close="closeModal">
        </notification-more-info-modal>
    </div>
</template>

<script>
import {Treeselect, ASYNC_SEARCH} from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {
    name: "notifications",
    props: ['environment'],
    components: {Treeselect},
    data() {
        return {
            api_params: {
                page: 1,
                order: 'created_at',
                order_direction: 'desc',
                search: '',
                agency_id: [],
                status: [],
                types: [],
            },
            pagination: {
                current_page: 1,
                total_pages: 1,
                from: 1,
                to: 1,
                total: 1
            },
            is_loading: false,
            statuses: [],
            types: [],
            agencies: [],
            notifications: [],
            headers: [
                {name: 'date', api_name: 'created_at', width: '145px', sort: 'desc', sortable: true,},
                {name: 'agency', api_name: 'agency_id', width: '165px', sort: null, sortable: true,},
                {name: 'type', api_name: 'type', width: '240px', sort: null, sortable: true,},
                {name: 'text', api_name: 'text', sort: null, sortable: true,},
                {name: 'status', api_name: 'status_id', width: '140px', sort: null, sortable: true,},
                {name: '', sort: null, width: '43px', sortable: false,}
            ],
            showModal: false,
            modalNotification: null,
            selectAllState: false,
            selectedNotifications: [],
            massUpdateStatusId: ''
        };
    },
    mounted() {
        this.getNotificationIfInUrl();
        this.initNotifications();
    },
    computed: {
        showLoading() {
            return this.is_loading;
        },
        showTableHeaders() {
            return this.is_loading === false && (this.hasNotifications || this.hasSearchOrStatus)
        },
        hasSearchOrStatus() {
            return this.api_params.search !== '' || this.api_params.status !== '';
        },
        showNoResultsFound() {
            return this.is_loading === false && this.hasNotifications === false && this.hasSearchOrStatus;
        },
        hasNotifications() {
            return this.notifications.length > 0;
        },
        isShowModal() {
            return this.showModal && this.modalNotification !== null;
        },
        showPagination() {
            return this.hasNotifications;
        },
        hasSelectedNotifications() {
            return this.selectedNotifications.length > 0;
        }
    },
    methods: {
        getNotificationIfInUrl() {
            if (!this.isIdInUrl()) {
                return;
            }

            axios.get('/notifier/' + this.getIdFromUrlHash())
                .then(response => {
                    this.showMoreInfo(response.data);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        isIdInUrl() {
            return this.getIdFromUrlHash() !== '';
        },
        getIdFromUrlHash() {
            return window.location.hash.replace('#/', '');
        },
        initNotifications() {
            Promise.all([this.getNotificationStatuses(), this.getNotificationTypes(), this.getAgencies()])
                .then(() => {
                    this.getNotifications();
                });
        },
        getNotificationStatuses() {
            return new Promise((resolve) => {
                axios.get('/notifier/statuses')
                    .then(response => {
                        this.statuses = response.data;

                        this.statuses.forEach((value) => {
                            this.api_params.status.push(value.id);
                        }, this);
                        resolve();
                    });
            });

        },
        getNotificationTypes() {
            return new Promise((resolve) => {
                axios.get('/notifier/types')
                    .then(response => {
                        this.types = response.data;

                        this.types.find(t => t.id === 'dev').children.forEach((value) => {
                            this.api_params.types.push(value.id);
                        }, this);
                        resolve();
                    });
            });
        },
        getAgencies() {
            return new Promise(resolve => {
                axios.get('/notifier/agencies')
                    .then(response => {
                        this.agencies = response.data;
                        resolve();
                    });
            })
        },
        agencyTreeSelectNormalizer(agency) {
            return {
                id: agency.id,
                label: agency.name + ' (' + agency.id + ')'
            }
        },
        getNotifications() {
            this.is_loading = true;
            axios.post('/notifier/data', this.api_params)
                .then(response => {
                    this.notifications = response.data.data;
                    this.pagination.current_page = response.data.current_page;
                    this.pagination.total_pages = response.data.last_page;
                    this.pagination.from = response.data.from;
                    this.pagination.to = response.data.to;
                    this.pagination.total = response.data.total;
                    this.is_loading = false;
                });
        },
        sortHeader(name) {
            let header = this.getHeaderByName(name);
            let currentSort = header.sort;

            if (header.sortable === false) {
                return;
            }

            this.resetHeaderSort();

            switch (currentSort) {
                case null:
                    header.sort = 'asc';
                    break;
                case 'asc':
                    header.sort = 'desc';
                    break;
                case 'desc':
                    header.sort = 'asc';
                    break;
            }

            this.api_params.order = header.api_name;
            this.api_params.order_direction = header.sort;

            this.getNotifications();
        },
        getHeaderByName(name) {
            return this.headers.find(h => h.name === name);
        },
        getHeaderWidth(header) {
            return (header.hasOwnProperty('width')) ? header.width : false;
        },
        resetHeaderSort() {
            this.headers.forEach(h => h.sort = null);
        },
        showMoreInfo(notification) {
            window.history.pushState({page: notification.id}, notification.text, '#/' + notification.id);
            this.modalNotification = notification;
            this.showModal = true;
        },
        closeModal() {
            window.history.pushState({page: 0}, 'Notifications | IFP Config', '/notifier');
            this.modalNotification = null;
            this.showModal = false;
        },
        search() {
            this.api_params.page = 1;
            this.getNotifications();
        },
        handleGoToPage(page) {
            this.api_params.page = page;
            this.getNotifications();
        },
        saveMassStatusUpdate() {
            axios.post('/notifier/update-statuses', this.getMassStatusUpdateData())
                .then(response => {
                    if (response.data.status === 'ok') {
                        this.selectedNotifications.forEach(id => {
                            let notification = this.notifications.find(n => n.id === id);

                            notification.status = this.getStatusObjectInNotificationStructure(this.massUpdateStatusId);
                            notification.status_id = this.massUpdateStatusId;
                        });

                        this.selectedNotifications = [];
                        this.massUpdateStatusId = '';
                    } else {
                        console.log(response);
                    }
                });
        },
        getMassStatusUpdateData() {
            return {
                ids: this.selectedNotifications,
                status_id: this.massUpdateStatusId
            };
        },
        getStatusObjectInNotificationStructure(status_id) {
            let status = this.statuses.find(s => s.id === status_id);
            return {
                id: status.id,
                name: status.label
            };
        },
        applyFilterByAgency(id) {
            this.api_params.agency_id.push(id);
            this.search();
        },
        applyFilterByStatus(id) {
            this.api_params.status = [id];
            this.search();
        },
        applyFilterByType(type) {
            this.api_params.types = [type];
            this.search();
        },
    },
    watch: {
        selectAllState(state) {
            this.selectedNotifications = state
                ? this.notifications.map(n => n.id)
                : [];
        }
    }
}
</script>

<style scoped>
.microsites-table {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
}
</style>